import React, { useEffect, useState } from 'react';
import { Select, Spin, message } from 'antd';
import debounce from 'lodash/debounce';
import axios from 'axios';
import { Avatar } from '@mui/material';
import { apiGetAllCustomerByeReplacementType } from '@services/ManageCustomers/CustomerServices';
import moment from 'moment';
import dayjs from 'dayjs';

const { Option } = Select;

const CustomerSelectByReplacementType = ({ onChange, initValue, disabled, type, date }) => {
  const [customers, setCustomers] = useState([]);
  const [loading, setLoading] = useState(false);
  const [customerSelected, setCustomerSelected] = useState(null);
  const formattedDate = date ? dayjs(date).format('YYYY-MM-DD HH:mm:ss') : undefined;

  const fetchCustomers = async (searchText) => {
    setLoading(true);
    try {
      const response = await apiGetAllCustomerByeReplacementType({
        keyWord: searchText ?? undefined,
        type: type,
        date: formattedDate,
        page: 1,
        size: 3000
      });
      setCustomers(response.data?.data || []);
    } catch (error) {
      message.error('Có lỗi khi lấy thông tin khách hàng!');
      console.error('Failed to fetch customers', error);
    }
    setLoading(false);
  };

  const handleSearch = debounce((value) => {
    fetchCustomers(value);
  }, 500);

  const handleChange = (value) => {
    setCustomerSelected(value);
    onChange && onChange(value);
  };

  useEffect(() => {
    setCustomerSelected(null);
    fetchCustomers();
  }, [type, formattedDate]);

  useEffect(() => {
    if (initValue && customers.length > 0) {
      const customerFound = customers.find((customer) => customer.code === initValue);
      if (customerFound) {
        setCustomerSelected({
          value: customerFound.code,
          label: `${customerFound.code} - ${customerFound.name}`,
          title: customerFound
        });
      }
    }
  }, [initValue, customers]);

  useEffect(() => {
    if (!initValue) {
      setCustomerSelected(null);
    }
  }, [initValue]);

  // Ensure no duplicate options are rendered
  const uniqueCustomers = Array.from(
    new Map(customers.map((customer) => [customer.code, customer])).values()
  );

  const renderCustomerOption = (customer) => (
    <Option
      key={customer.code}
      value={customer.code}
      label={`${customer.code} - ${customer.name}`}
      title={customer}>
      <div style={{ display: 'flex', alignItems: 'center' }}>
        <Avatar
          alt={customer?.name?.toUpperCase()}
          src={customer.avatar ? customer?.avatar : 'https://'}
          sx={{ bgcolor: '#00904A' }}
          style={{ marginRight: 8 }}
        />
        <div>
          <div style={{ fontSize: '14px', fontWeight: '400', color: '#0051A9' }}>
            {`${customer.code} - ${customer.name} (SN: ${customer.serial_number})`}
          </div>
          <div style={{ fontSize: '12px', color: '#626D7C', fontWeight: '400' }}>
            {customer.address}
          </div>
        </div>
      </div>
    </Option>
  );

  return (
    <Select
      disabled={disabled}
      loading={loading}
      showSearch
      labelInValue
      placeholder="Lựa chọn khách hàng"
      onChange={handleChange}
      value={customerSelected}
      notFoundContent={loading ? <Spin size="small" /> : null}
      filterOption={false}
      onSearch={handleSearch}
      style={{ width: '100%', height: '36px' }}
      optionLabelProp="label">
      {uniqueCustomers.map(renderCustomerOption)}
    </Select>
  );
};

export default CustomerSelectByReplacementType;
